import React from 'react';

import { learnJSData } from 'data/javascript/learn';

import DescriptionEntry from 'components/shared/description-entry';

const WorkSpaceSetup = () => {
  const item = learnJSData?.items.find(
    (item) => item.title === 'Workspace'
  );

  return <DescriptionEntry entry={item} />;
};
export default WorkSpaceSetup;
